import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

// Carga los JSON de traducción en runtime desde assets/i18n/{lang}.json
// (assets servido por angular.json desde src/assets → /assets).
export const translateHttpLoaderFactory = (http: HttpClient): TranslateHttpLoader =>
  new TranslateHttpLoader(http, './assets/i18n/', '.json');
